export default "__VITE_ASSET__yAFo4v6E__"